<template>
    <kgr-loading v-if="loading" />
    <div v-else>
        <div>
            <div
                class="kgr-alert kgr-alert--info kgr-row"
            >
                {{ tInfoText }}
            </div>
            <div class="kgr-row">
                <kgr-member-classification-select
                    v-model="newClassification.classification"
                    :club-id="clubId"
                />
            </div>
            <kgr-form-row
                :label="tLabelStart"
                :error="error"
                field-name="start"
            >
                <div
                    class="form-widget date-picker"
                    :class="{ invalid: (!newClassification.start || !isValidDateRange) }"
                >
                    <kgr-date-picker v-model="newClassification.start" />
                </div>
            </kgr-form-row>
            <kgr-form-row
                :label="tLabelEnd"
                :error="error"
                field-name="end"
            >
                <div
                    class="form-widget date-picker"
                    :class="{ invalid: !isValidDateRange }"
                >
                    <kgr-date-picker v-model="newClassification.end" />
                </div>
            </kgr-form-row>
            <kgr-form-row
                :label="tLabelNotice"
                :error="error"
                field-name="notice"
            >
                <textarea
                    v-model.trim="newClassification.notice"
                    rows="5"
                    class="kgr-input"
                    style="min-height: 6em;height: 6em"
                ></textarea>
            </kgr-form-row>
            <hr class="kgr-separator" />
            <div class="kgr-row">
                <button
                    class="kgr-button"
                    @click="$emit('onClose')"
                >
                    {{ tButtonCancel }}
                </button>
                <button
                    class="kgr-button"
                    :disabled="!isValidData || !isValidDateRange"
                    :value="tButtonExecuteTestRun"
                    @click="updateClassifications(true)"
                >
                    {{ tButtonExecuteTestRun }}
                </button>
                <button
                    class="kgr-button kgr-button--danger"
                    :disabled="!isValidData || !isValidDateRange"
                    :value="tButtonExecute"
                    @click="updateClassifications(false)"
                >
                    {{ tButtonExecute }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { isBefore, parse } from '@legacy/js/date/date-fns.js'
import BatchMemberClassification from './BatchMemberClassification.js';
import DatePicker from '../../../../../common/form/picker/DatePicker';
import Error from '../../../../../../js/model/Error';
import FormRow from '../../../../../common/form/FormRow';
import Loading from '../../../../../common/Loading.vue';
import MemberClassificationSelect from '../../../../../members/classification/MemberClassificationSelect.vue';

export default {
    components: {
        'kgr-member-classification-select': MemberClassificationSelect,
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
        'kgr-loading': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        listId: {
            type: Number,
            required: true,
        },
        entityIds: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        savedActionData: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            newClassification: new BatchMemberClassification(),
            error: new Error()
        };
    },
    computed: {
        isValidDateRange() {
            if (!this.newClassification.end) {
                return true;
            }
            return isBefore(parse(this.newClassification.start, 'dd.MM.yyyy', new Date()), parse(this.newClassification.end, 'dd.MM.yyyy', new Date()));
        },
        tButtonCancel() {
            return this.$t('Abbrechen');
        },
        isValidData() {
            return this.newClassification.isValid();
        },
        tLabelStart() {
            return this.$t('Startdatum');
        },
        tLabelEnd() {
            return this.$t('Enddatum');
        },
        tLabelNotice() {
            return this.$t('Bemerkungen');
        },
        tInfoText() {
            if(this.newClassification.start && this.newClassification.classification) {
                return this.$t('Allen {count} Mitgliedern wird die Zuordnung "{classification}" zum {startDate} zugewiesen', {count: this.entityIds.length, classification: this.newClassification.classification.value, startDate: this.newClassification.start });
            }
            return this.$t('Allen {count} Mitgliedern wird die ausgewählte Zuordnung zugewiesen', {count: this.entityIds.length });
        },
        tButtonExecute() {
            return this.$t('Ausführen');
        },
        tButtonExecuteTestRun() {
            return this.$t('Testlauf ausführen');
        },
    },
    mounted() {
        this.assignDefaultData();
    },
    updated() {
        this.assignDefaultData();
    },
    methods: {
        updateClassifications(isTestRun) {
            if(!this.newClassification.isValid())  {
                return;
            }
            this.$emit('executeAction', this.newClassification, isTestRun);
        },
        assignDefaultData() {
            this.newClassification.ids = this.entityIds;
            if(this.savedActionData !== null && this.savedActionData instanceof BatchMemberClassification) {
                this.newClassification = this.savedActionData
            }

        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
